export default function GlobalFlagshipNav () {
    return (

        <ul class="g-nav_flagship" data-reactroot="">
            <li><a href="/alpineflagship">Info de producto</a></li>
            <li><a href="/alpineflagship/aprendemas/">Tecnología / Características</a></li>
            <li><a href="/alpineflagship/producto/">Lista de especificaciones</a></li>
        </ul>
    )
}